module.exports = __webpack_public_path__ + "img/PadCircuitDiagram.17b3306d.png";